import Private from "./Private.jsx"

export default Private;